import { IEvent } from '../../models/Event'
import { AuthorizationActions } from '../userAccount/actionNames'
import initialStore from './initialState'
import { ClientActions } from './actionNames'

export default function(
  store: Readonly<IClientStore> = initialStore,
  action: any,
): IClientStore {
  switch (action.type) {
    case ClientActions.GetClients:
      return {
        ...initialStore,
        isLoading: true,
      }
    case ClientActions.PutClients:
      return {
        ...store,
        clients: action.clients,
        isLoading: false,
      }
    case ClientActions.SetFilter:
      return {
        ...store,
        filter: action.filter,
        page: 1,
      }
    case ClientActions.SetOrder:
      return {
        ...store,
        by: action.order.by,
        direction: action.order.direction,
        page: 1,
      }
    case ClientActions.SetPage:
      return {
        ...store,
        page: action.page,
      }
    case ClientActions.SetPagination:
      return {
        ...store,
        page: 1,
        pagination: action.pagination,
      }
    case ClientActions.SetInfoModalEvents:
      return {
        ...store,
        id: action.id,
        isOpen: true,
        reservations: action.reservations,
      }
    case ClientActions.CloseInfoModal:
      return {
        ...store,
        isOpen: false,
      }
    case AuthorizationActions.FlushState:
      return { ...initialStore }
  }

  return store
}

export interface IClientStore {
  isLoading: boolean
  isOpen: boolean
  id: number
  reservations: IEvent[]
  clients: IClient[]
  page: number
  maxPage: number
  pagination: number
  filter: string
  by: ClientOrder | null
  direction: 'up' | 'down' | null
}

export enum ClientOrder {
  Id,
  Name,
  Phone,
  Email,
}

export interface IClient {
  id: number
  name: string
  phone: string
  email: string
}
